import React from "react";
import About1 from "../../../assets/images/OwnerCar.jpg";
import About2 from "../../../assets/images/about-2.jpg";
import Shape1 from "../../../assets/images/shape-11.png";
// import Signature from "../../../assets/images/signature-1.png";
import { Link } from "react-router-dom";
import { config } from "../config";

const AboutSection = () => {
  return (
    <div>
      <section className="about-section mt-md-0 mt-5">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-8 col-md-12 col-sm-12 big-column ">
              <div className="inner-box">
                <div className="title-text">
                  <h2>A Premier Driving School with Modern Vehicles</h2>
                </div>
                <div className="row clearfix">
                  <div className="col-lg-6 col-md-6 col-sm-12 image-column">
                    <div className="image-box">
                      <figure className="image">
                        <img src={About1} alt="" />
                      </figure>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 content-column">
                    <div className="content-box">
                      <h6>Since</h6>
                      <h2>2006</h2>
                      <div className="text">
                        <p className="lineHeight">
                          At Precision Driving, we’ve been dedicated to helping learners master the art of driving for nearly two decades. Our fleet of the latest vehicles, combined with experienced instructors, ensures that every student gain confidence, safety, and skill on the road.
                        </p>
                        <p className="lineHeight">
                          Our mission is simple: to empower our students with the knowledge and expertise to become safe, responsible rider. Whether you’re a beginner or someone looking to enhance your driving skills, we tailor our lessons to meet your specific needs.
                        </p>
                      </div>
                      <div className="inner">
                        {/* <figure className="signature">
                          <img src={Signature} alt="" />
                        </figure> */}
                        <div className="author">
                          <h4>Nelson Adomako</h4>
                          <span className="designation">Director</span>
                        </div>
                      </div>
                      <div className="btn-box">
                        <Link
                          to={`${config.appUrl}instructors`}
                          className="theme-btn btn-two"
                        >
                          Find an Instructor
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 small-column position-relative">
              <div className="image-box">
                <div
                  className="shape"
                  style={{ backgroundImage: `url(${Shape1})` }}
                ></div>
                <figure className="image">
                  <img src={About2} alt="" />
                </figure>
                {/* <div className="social-links">
                  <h6>Follow Me On</h6>
                  <ul className="social-list clearfix">
                    <li>
                      <a href="#">
                        <i className="bi bi-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="bi bi-twitter-x"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="bi bi-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="bi bi-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutSection;
